import { Box, Header } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import Picture from 'components/picture';
import SanityBlockRenderer from 'components/sanity-block-renderer';
import { spacing } from 'styles/constants';

import theme from './theme';

// item picture
export const StyledPicture = Picture.withConfig({
  maxWidth: '100px',
  height: '68px',
});

// item name
export const Name = Header.withConfig({
  fontFamily: 'heading',
  fontSize: 'md',
  lineHeight: '2xs',
  margin: '$0',
});

// item description
export const StyledDescriptionSanityBlockRenderer = SanityBlockRenderer.withConfig({
  textProps: {
    fontFamily: 'body',
    fontSize: 'sm',
    lineHeight: 14,
  },
});

export const StyledLoyaltyPointsIcon = LoyaltyPointsIcon.withConfig({
  fill: theme.itemDescriptionDefaultColor,
  width: '18px',
});

export const RewardItemDescriptionWrapper = Box.withConfig({
  alignItems: 'center',
  flexDirection: 'row',
});

export const RewardItemDescriptionDetail = withTypography({
  fontFamily: 'heading',
  fontSize: theme.itemDescriptionFontSize,
  color: theme.itemDescriptionDefaultColor,
  lineHeight: theme.itemDescriptionLineHeight,
  style: {
    textTransform: 'capitalize',
    marginLeft: spacing.$0_5,
  },
});
